import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import { log } from "../utils/logger";
import { isLocal } from "../utils/env";

// Generators
import generateData from "./generateData";

const MOCK_CALLS = [
  // 'auth', // Mock authentication
  // "campaign", // Mock campaign calls
  // "dataset", // Mock dataset calls
];

if (isLocal()) {
  log("%cSetting up mock calls", "color: green; font-weight: bold;");

  // This sets the mock adapter on the default instance
  const mock = new MockAdapter(axios);

  // ==============================================================================================
  // Auth =========================================================================================
  // ==============================================================================================

  if (MOCK_CALLS.includes("auth")) {
    mock.onPost("auth/log-in").reply(200, {
      status: "success",
      user: require("./generateUser"),
      token: "SAMPLE_TOKEN",
    });
    mock.onGet("user").reply(200, {
      status: "success",
      user: require("./generateUser"),
    });
  }

  // ==============================================================================================
  // Campaigns ====================================================================================
  // ==============================================================================================

  if (MOCK_CALLS.includes("campaign")) {
    mock.onGet("campaign").reply(() => [
      200,
      {
        status: "success",
        campaigns: require("./generateCampaigns").default(),
      },
    ]);
  }

  // ==============================================================================================
  // Datasets =====================================================================================
  // ==============================================================================================

  if (MOCK_CALLS.includes("dataset")) {
    // Data values are used to get meta-data, so generate those first
    const data = generateData();

    mock.onGet("dataset").reply(() => [
      200,
      {
        status: "success",
        datasets: require("./generateDatasets").default(),
      },
    ]);

    mock.onGet("dataset/filters").reply(() => [
      200,
      {
        status: "success",
        filters: require("./generateDatasetFilters").default(),
      },
    ]);

    mock.onGet(/dataset\/filter\/*/).reply((config) => {
      const parse_url = /dataset\/filter\/(.+)/.exec(config.url)[1];

      return [
        200,
        {
          status: "success",
          options: require("./generateDataFilter").default(data, parse_url),
        },
      ];
    });

    mock
      .onPut("/dataset")
      .replyOnce(500, {
        status: "error",
        error: "Sample error",
      })
      .onPut("/dataset")
      .reply(200, {
        status: "success",
        dataset: { id: 1 },
      });
  }

  // Forward unmatched APIs through the network
  mock.onAny().passThrough();
}
